import { sectionNames } from "@saleor/intl";
import WebhooksRoutes from "@saleor/webhooks";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import {
  AppDetailsUrlQueryParams,
  appInstallPath,
  AppInstallUrlQueryParams,
  AppListUrlQueryParams,
  appPath,
  appSettingsPath,
  appsListPath,
  customAppAddPath,
  customAppPath,
  CustomAppUrlQueryParams
} from "./urls";
import AppDetailsView from "./views/AppDetails";
import AppDetailsSettingsView from "./views/AppDetailsSettings";
import AppInstallView from "./views/AppInstall";
import AppsListView from "./views/AppsList";
import CustomAppCreateView from "./views/CustomAppCreate";
import CustomAppDetailsView from "./views/CustomAppDetails";

const AppDetails: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const qs = parseQs(location.search.substr(1));
  const params: AppDetailsUrlQueryParams = qs;

  return <AppDetailsView id={decodeURIComponent(id)} params={params} />;
};

const AppDetailsSettings: React.FC = () => {
  const { id } = useParams();
  return <AppDetailsSettingsView id={decodeURIComponent(id)} />;
};

const AppInstall: React.FC = props => {
  const location = useLocation();
  const qs = parseQs(location.search.substr(1));
  const params: AppInstallUrlQueryParams = qs;

  return <AppInstallView params={params} {...props} />;
};

interface CustomAppDetailsProps {
  token: string;
  onTokenClose: () => void;
}

const CustomAppDetails: React.FC<CustomAppDetailsProps> = ({
  token,
  onTokenClose
}) => {
  const location = useLocation();
  const { id } = useParams();
  const qs = parseQs(location.search.substr(1));
  const params: CustomAppUrlQueryParams = qs;

  return (
    <CustomAppDetailsView
      id={decodeURIComponent(id)}
      params={params}
      token={token}
      onTokenClose={onTokenClose}
    />
  );
};

const AppsList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substr(1));
  const params: AppListUrlQueryParams = qs;

  return <AppsListView params={params} />;
};
const Component = () => {
  const intl = useIntl();
  const [token, setToken] = React.useState<string>(null);

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.apps)} />
      <Routes>
        <Route path={appsListPath} element={<AppsList />} />
        <Route
          path={customAppAddPath}
          element={<CustomAppCreateView setToken={setToken} />}
        />
        <Route path={appInstallPath} element={<AppInstall />} />
        <Route path={appPath(":id")} element={<AppDetails />} />
        <Route path={appSettingsPath(":id")} element={<AppDetailsSettings />} />
        <Route
          path={customAppPath(":id")}
          element={
            <CustomAppDetails
              token={token}
              onTokenClose={() => setToken(null)}
            />
          }
        />
        <WebhooksRoutes />
      </Routes>
    </>
  );
};

export default Component;
